import React, { useMemo } from 'react';
import { TwoLinesPharmacyCalendarDatePickerProps } from './PharmacyCalendarDatePickersProps';
import styled from '@emotion/styled';
import { PharmacyCalendarDatePicker } from './PharmacyCalendarDatePicker';
import { CalendarPerfMonitor } from '../CalendarPerfMonitor';

const buildMonths = (
  year: number,
  startMonth: number,
  modifiers: Record<string, (day: Date) => boolean>,
  onChange: (date: Date) => void,
): JSX.Element[] => {
  const months: JSX.Element[] = [];
  for (let i = startMonth; i < startMonth + 6; i++) {
    const maxDate = i === 11 ? new Date(year + 1, 0) : new Date(year, i + 1);
    maxDate.setDate(maxDate.getDate() - 1);
    months.push(
      <span key={i - startMonth}>
        <PharmacyCalendarDatePicker
          initialMonth={new Date(year, i)}
          minDate={new Date(year, i)}
          maxDate={maxDate}
          modifiers={modifiers}
          onChange={onChange}
        />
      </span>,
    );
  }
  return months;
};

export const TwoLinesPharmacyCalendarDatePicker = ({
  year,
  initialMonth,
  yearSecondLine,
  initialMonthSecondLine,
  modifiers,
  onChange,
}: TwoLinesPharmacyCalendarDatePickerProps) => {
  const firstLine = useMemo(
    () => CalendarPerfMonitor.measure('buildMonths.line1', () => buildMonths(year, initialMonth, modifiers, onChange)),
    [year, initialMonth, modifiers, onChange],
  );

  const secondLine = useMemo(
    () => CalendarPerfMonitor.measure('buildMonths.line2', () => buildMonths(yearSecondLine, initialMonthSecondLine, modifiers, onChange)),
    [yearSecondLine, initialMonthSecondLine, modifiers, onChange],
  );

  return (
    <>
      <DivLine>{firstLine}</DivLine>
      <DivLine>{secondLine}</DivLine>
    </>
  );
};

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
`;
